import useDebounce from '@/common/hooks/useDebounce.ts';
import { plateDesignRequest } from '@/common/queries/selections/plateDesign';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

const usePlateDesignRequest = (options: { enabled: boolean }) => {
  const [plateDesign, setPlateDesign] = useState<string>('');
  const debounce = useDebounce();
  const onPlateDesignSearchChange = (value: string) => {
    if (value) {
      debounce(() => {
        setPlateDesign(value);
      }, 1000);
    } else {
      setPlateDesign(value);
    }
  };

  const plateDesignQuery = useQuery({
    enabled: options.enabled,
    queryKey: ['plateDesign', plateDesign],
    queryFn: () => plateDesignRequest({ plateDesignName: plateDesign }),
    select: (data) =>
      data?.results?.map((item) => ({
        label: item.fa_const,
        value: item.const,
      })),
  });
  return { plateDesignQuery, onPlateDesignSearchChange };
};

export default usePlateDesignRequest;
